<template>
  <ul class="category-list list-group">
    <li
      class="category-list__item list-group-item border-bottom border-white"
      :class="{ active: isAllChecked }"
      @click="toggleAll">
      全て選択
    </li>
    <li
      v-for="category in _categories"
      :key="category.id"
      class="category-list__item list-group-item border-bottom border-white"
      :class="{ active: isActive(category.id) }"
      @click.self="toggleMenu(category.id)">
      {{ category.name }}
      <div
        class="pin-icon-wrapper"
        @click="togglePin(category.id)">
        <pin-icon
          :is-pinned="isPinned(category.id)"
          white />
      </div>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import PinIcon from '@/components/parts/PinIcon.vue'

export default {
  components: {
    PinIcon
  },
  computed: {
    ...mapState('events', [
      'selectedCategories', 'categories', 'pinnedCategories'
    ]),
    _selectedCategories: {
      get() {
        return this.selectedCategories
      },
      set(v) {
        this.$store.commit('events/setSelectedCategories', v)
      }
    },
    isAllChecked() {
      return this._selectedCategories.length === this.categories.length
    },
    _pinnedCategories: {
      get() {
        return this.pinnedCategories
      },
      set(v) {
        this.$store.commit('events/setPinnedCategories', v)
      }
    },
    _categories() {
      const categories = [...this.categories].sort(
        (x, y) => {
          if (!this.isPinned(x.id) && this.isPinned(y.id)) {
            return 1
          }
          if (this.isPinned(x.id) && !this.isPinned(y.id)) {
            return -1
          }
          return 0
        }
      )
      return categories
    }
  },
  methods: {
    isActive(categoryId) {
      return this._selectedCategories.includes(categoryId)
    },
    toggleMenu(categoryId) {
      if (this.isActive(categoryId)) {
        this._selectedCategories = this._selectedCategories.filter(category => category !== categoryId)
        return
      }
      this._selectedCategories = [...this._selectedCategories, categoryId]
    },
    toggleAll() {
      this._selectedCategories = this.isAllChecked ? [] : [...this.categories.map(category => category.id)]
    },
    isPinned(categoryId) {
      return this._pinnedCategories.includes(categoryId)
    },
    togglePin(categoryId) {
      if (this.isPinned(categoryId)) {
        this._pinnedCategories = this._pinnedCategories.filter(pinnedId => pinnedId !== categoryId)
      } else {
        this._pinnedCategories = [...this._pinnedCategories, categoryId]
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.category-list {
  height: calc(100vh - 220px);
  margin-bottom: 100px;
  overflow-y: scroll;
  border-top: 1px solid $grey02;
  border-bottom: 1px solid $grey02;
}

.category-list__item {
  position: relative;
}

.pin-icon-wrapper {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 40%;
  right: 3.5%;
  transform: translateY(-50%);
  border-radius: 3px;

  .pin-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
  }
}
</style>